export interface Volume {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

const covers = [
  'https://cdn.magicpatterns.com/uploads/6UPTffLknvyYrDTRXnyvPA/ChatGPT-Image-21-jul-2026_-06_23_34-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/hBNBxZ4ryr1KoYVXVs9urw/ChatGPT-Image-21-jul-2026_-06_23_40-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/hrQM47RHycoXn5Kqd6Lar2/ChatGPT-Image-21-jul-2026_-06_23_46-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/w2uvKZwqVDf2HoekqnhcU3/ChatGPT-Image-21-jul-2026_-06_23_51-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/uocEbCv2X1v5cQ5jRy9Lnv/ChatGPT-Image-21-jul-2026_-06_23_56-p.m..webp',
  'https://cdn.magicpatterns.com/uploads/usTH22qxaEwnazKL6YbJp2/ChatGPT-Image-21-jul-2026_-06_24_01-p.m..webp',
];

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Elements of Art™',
    description:
      'The visual language behind every artwork. Give students a clear foundation for seeing, describing and intentionally using the Elements of Art—not just memorizing seven definitions. They observe, experiment, create and explain how visual choices affect an artwork.',
    tag: 'Line · Shape · Form · Color · Value · Texture · Space',
    coverImage:
      'https://cdn.magicpatterns.com/patterns/generated-images/800044ad-a8a2-4630-a402-cf7bab1843bd.jpg',
  },
  {
    number: '02',
    title: 'Drawing & Illustration™',
    description:
      'From careful observation to confident visual communication. Help students move beyond “I can’t draw” with practical strategies for observing, constructing, shading, revising and communicating through drawing. The focus is on developing drawing processes—not copying one finished example.',
    tag: 'Observation · Contour · Proportion · Value · Perspective · Portraits · Illustration',
    coverImage:
      'https://cdn.magicpatterns.com/patterns/generated-images/9f8e408c-9628-45e2-9cb7-066a922a66c0.jpg',
  },
  {
    number: '03',
    title: 'Color, Painting & Mixed Media™',
    description:
      'Explore color, materials and technique through real experimentation. Visual experiments, painting techniques and mixed-media projects turn color into something students investigate, test and use intentionally—comparing possibilities before making artistic choices instead of filling spaces with color.',
    tag: 'Color Theory · Mixing · Painting · Brushwork · Texture · Collage · Mixed Media',
    coverImage:
      'https://cdn.magicpatterns.com/patterns/generated-images/c5fabb1e-e659-4094-9be1-38ff3e0afbd3.jpg',
  },
  {
    number: '04',
    title: 'Principles of Design™',
    description:
      'Help students understand how visual choices shape a composition. They compare, rearrange and revise compositions to see how artists guide attention, create balance and communicate visually. Design principles become strategies students can test—not rules they simply memorize.',
    tag: 'Balance · Contrast · Emphasis · Movement · Rhythm · Scale · Unity · Hierarchy',
    coverImage:
      'https://cdn.magicpatterns.com/patterns/generated-images/8a578626-747c-4a64-9943-c21331a6b88a.jpg',
  },
  {
    number: '05',
    title: 'Art, Artists & Visual Cultures™',
    description:
      'Move beyond biographies and teach students how to look, question and connect. Explore artworks, artists and visual traditions through observation, historical context, comparison and evidence-based interpretation. Art History becomes a way to understand people, ideas and visual culture across time.',
    tag: 'Art History · Artists · Visual Analysis · Culture · Context · Interpretation',
    coverImage:
      'https://cdn.magicpatterns.com/patterns/generated-images/64f27491-8dc3-41b2-aa00-b9cc35a87433.jpg',
  },
  {
    number: '06',
    title: 'Art Projects & Creative Challenges™',
    description:
      'Meaningful projects for the moments when students put everything together. A classroom-ready project library where they generate ideas, experiment, solve visual problems, create, revise and reflect—so you get a real Art project without spending your evening designing one from scratch.',
    tag: 'Drawing · Painting · Design · Mixed Media · 3D · Collaboration · Creative Challenges',
    coverImage:
      'https://cdn.magicpatterns.com/patterns/generated-images/5d77935d-9ef3-4628-b02f-4da8414f5206.jpg',
  },
];

export interface Bonus {
  badge: string;
  icon: string;
  title: string;
  description: string;
  value: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    icon: '📊',
    title: 'Art Assessment Made Simple™',
    description:
      "When every student's artwork looks different, grading shouldn't feel like guesswork. Use clear rubrics, formative checks, self-assessment, peer feedback and progress tools to evaluate learning without grading artistic talent or personal taste.",
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 2',
    icon: '📅',
    title: 'The Art Teacher Planner™',
    description:
      'Having the resources is one thing. Knowing how they fit across the year is another. Plan from yearly goals to units, projects, materials and assessment—including a sample 36-week Art roadmap you can adapt to your classes.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 3',
    icon: '⏱️',
    title: '10-Minute Art Rescue™',
    description:
      "Ten minutes left? Early finishers? A schedule change you didn't expect? Keep a bank of meaningful, low-prep Art prompts ready for short classroom windows—without falling back on filler activities.",
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 4',
    icon: '🖼️',
    title: 'Art Classroom Visuals™',
    description:
      'Stop re-explaining the same core Art concepts from scratch. Keep clear visual references for the Elements of Art, Principles of Design, color, shading, perspective, critique and studio routines ready to display or print.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 5',
    icon: '🗂️',
    title: 'Student Art Portfolio™',
    description:
      'Student growth should be visible—not buried in a stack of finished artwork. Help students document ideas, experiments, revisions, final work and reflection so progress becomes easier to see, discuss and assess over time.',
    value: 'Value: $47 USD',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  location: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'I got my Sundays back. The projects are clear, inspiring, and easy to adapt.',
    name: 'Sarah M.',
    location: 'Austin, USA',
  },
  {
    text: 'The progression throughout the year is exactly what my class needed.',
    name: 'Ella B.',
    location: 'Bristol, United Kingdom',
  },
  {
    text: 'The low-cost ideas make a real difference in my Art classroom.',
    name: 'Ada O.',
    location: 'Lagos, Nigeria',
  },
  {
    text: 'The rubrics have made assessment feel much clearer, calmer, and genuinely useful.',
    name: 'Maya K.',
    location: 'Toronto, Canada',
  },
  {
    text: 'A practical, valuable resource that saves me hours every week.',
    name: 'Sophie L.',
    location: 'Melbourne, Australia',
  },
  {
    text: 'Every file is so well organized. It feels like it was created by someone who actually understands teachers.',
    name: 'Tara N.',
    location: 'Singapore',
  },
];

export interface PurchaseNotification {
  name: string;
  location: string;
  time: string;
}

export const notifications: PurchaseNotification[] = [
  { name: 'Sarah M.', location: 'Toronto, Canada', time: '2 minutes ago' },
  { name: 'James R.', location: 'Manchester, United Kingdom', time: '5 minutes ago' },
  { name: 'Anjali P.', location: 'Mumbai, India', time: '8 minutes ago' },
  { name: 'Maria R.', location: 'Manila, Philippines', time: '14 minutes ago' },
];

export const faqs = [
  {
    question: 'Is this a subscription?',
    answer:
      'No. THE COMPLETE ART YEAR™ is a one-time purchase. There is no monthly subscription or automatic renewal.',
  },
  {
    question: 'What exactly will I receive?',
    answer:
      "You'll receive 6 core Visual Arts teaching volumes plus 5 professional teacher bonuses covering assessment, yearly planning, quick classroom activities, visual references and student portfolios.",
  },
  {
    question: 'How will I receive the resources?',
    answer:
      'This is a digital product. After purchase, access instructions are sent to the email address you use at checkout. Make sure that email address is entered correctly.',
  },
  {
    question: 'Can I keep the resources?',
    answer:
      'Yes. Your purchase includes lifetime access to the digital resources included with THE COMPLETE ART YEAR™.',
  },
  {
    question: 'Can I print or project the resources?',
    answer:
      'Yes. The resources are designed to be practical in the classroom. You can print student materials and use appropriate pages or visuals for projection with your own classes.',
  },
  {
    question: 'Which grade levels is this designed for?',
    answer:
      'THE COMPLETE ART YEAR™ is designed to support Elementary, Middle School and High School Visual Arts teaching. Many resources include ways to simplify, extend or deepen the learning depending on the age and needs of your students.',
  },
  {
    question: 'Is this a training course or a video course?',
    answer:
      'No. This is a digital teaching-resource system for Art teachers, not a certification program or professional-development video course.',
  },
  {
    question: 'Are the resources really visual?',
    answer:
      'Yes. Visual explanation is built into the system through diagrams, examples, technique guides, comparisons, classroom posters and reference tools. The goal is instructional clarity—not decoration for its own sake.',
  },
  {
    question: 'I already use my own Art resources. Can I use these alongside them?',
    answer:
      'Absolutely. THE COMPLETE ART YEAR™ is designed to support your teaching, not replace it. You can use complete lessons or select individual activities, visuals, projects, assessment tools and planning resources alongside the materials you already trust.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. THE COMPLETE ART YEAR™ is entirely digital. No physical books or printed materials are shipped.',
  },
  {
    question: 'Can I use the resources with my students?',
    answer:
      'Yes. The resources are designed for the purchasing teacher to use with their own classes. Student materials may be printed or used in class as intended, but the complete digital files should not be redistributed or resold.',
  },
  {
    question: 'Are all the resources in English?',
    answer:
      'Yes. THE COMPLETE ART YEAR™ is created in English for English-speaking Visual Arts classrooms.',
  },
  {
    question: 'Do I need to install an app?',
    answer:
      'No dedicated app is required to use the teaching system. You only need a device capable of opening the digital resources you receive.',
  },
  {
    question: 'Can I request a refund?',
    answer:
      "The purchase is covered by the guarantee period shown on this page. If the product isn't the right fit, contact support within that period and follow the refund terms provided with your purchase.",
  },
];

export const CHECKOUT_URL = 'https://the-complete-art-year.impultienda.ar/checkout';
